module.exports = __webpack_public_path__ + "static/media/settings.76e135a5.svg";